import { useWorkflow, type TaskStatus } from '../WorkflowContext';
import Tag from '../components/Tag';

const COLUMNS: [TaskStatus, string][] = [
  ['assigned', 'Assigned'],
  ['acknowledged', 'Acknowledged'],
  ['in_progress', 'In Progress'],
  ['blocked', 'Blocked'],
];

export default function TaskBoard() {
  const wf = useWorkflow();

  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">Task Board</div>
          <div className="page-sub">Every task has one owner, department, due date, acknowledgment, status, and evidence.</div>
        </div>
        <div className="global-actions">
          <button className="btn small" onClick={() => wf.submitIntake({ source: 'Phone Call', client: 'Acme Nutraceutical Packaging', text: 'Sample request for three SKUs.' })}>Create Sample Task</button>
          <button className="btn small danger" onClick={wf.simulateOverdue}>Simulate Overdue</button>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><div><h3>Kanban Task Board</h3><p>Assign work, require acknowledgment, manage due dates, escalate delays, close with evidence.</p></div></div>
        <div className="card-body">
          <div className="kanban">
            {COLUMNS.map(([key, label]) => {
              const items = wf.tasks.filter((t) => t.status === key);
              return (
                <div className="kanban-col" key={key}>
                  <div className="kanban-title"><span>{label}</span><span>{items.length}</span></div>
                  {items.map((t) => (
                    <div className="task-card" key={t.id}>
                      <h4>{t.title}</h4>
                      <div className="task-meta">
                        <Tag kind="dp" value={t.dept} />
                        <Tag kind="pr" value={t.priority} />
                      </div>
                      <p>{t.description}</p>
                      <div className="sub">Client: {t.client}<br />Owner: {t.owner} · Due: {t.due}</div>
                      <div className="task-actions">
                        {t.status === 'assigned' && <button className="btn small success" onClick={() => wf.ackTask(t.id)}>Acknowledge</button>}
                        <button className="btn small" onClick={() => wf.moveProgress(t.id)}>Move Forward</button>
                        <button className="btn small danger" onClick={() => wf.blockTask(t.id)}>Block</button>
                      </div>
                    </div>
                  ))}
                  {items.length === 0 && <div className="sub" style={{ padding: '6px' }}>No tasks.</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
